module.exports = __webpack_public_path__ + "static/media/iconHPA.eb226c19.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/Icons/iconHPA.svg
// module id = 888
// module chunks = 0